import { useState } from 'react';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { invoiceModel } from '~/models';
const awaitsPayment = (invoice)=>invoiceModel.isRequiresPaymentApproval(invoice) || invoiceModel.isPaymentFailed(invoice);
const useInvoicesAwaitingPayment = (invoiceIds)=>{
    const { api } = useStoreActions();
    const { data } = useQueryState({
        queryKey: [
            QueryKeys.Invoice,
            'chainedApproval',
            ...invoiceIds
        ],
        queryFn: ()=>Promise.allSettled(invoiceIds.map((invoiceId)=>api.invoice.getByID(invoiceId, true))).then((results)=>results.filter((result)=>result.status === 'fulfilled').map((result)=>result.value).filter(awaitsPayment).map(invoiceModel.id)),
        enabled: invoiceIds.length > 1
    });
    return data !== null && data !== void 0 ? data : invoiceIds.slice(0, 1);
};
export const useChainedInvoiceApproval = (payload)=>{
    var _ref, _ref1;
    var _payload_fundingSourceLapseScope;
    const [approvedInvoiceIds, setApprovedInvoiceIds] = useState([]);
    const [visitedInvoiceId, setVisitedInvoiceId] = useState(null);
    const [walkCompleted, setWalkCompleted] = useState(false);
    const affectedInvoiceIds = (_ref = payload === null || payload === void 0 ? void 0 : (_payload_fundingSourceLapseScope = payload.fundingSourceLapseScope) === null || _payload_fundingSourceLapseScope === void 0 ? void 0 : _payload_fundingSourceLapseScope.invoiceIds) !== null && _ref !== void 0 ? _ref : [];
    const invoiceIds = useInvoicesAwaitingPayment(affectedInvoiceIds);
    const approved = new Set(approvedInvoiceIds);
    const pendingInvoiceIds = invoiceIds.filter((invoiceId)=>!approved.has(invoiceId));
    const walkOrder = [
        ...invoiceIds.filter((invoiceId)=>approved.has(invoiceId)),
        ...pendingInvoiceIds
    ];
    const currentInvoiceId = walkCompleted ? undefined : visitedInvoiceId != null && pendingInvoiceIds.includes(visitedInvoiceId) ? visitedInvoiceId : pendingInvoiceIds[0];
    const pendingIndex = currentInvoiceId != null ? pendingInvoiceIds.indexOf(currentInvoiceId) : -1;
    const nextInvoiceId = pendingInvoiceIds[pendingIndex + 1];
    const previousInvoiceId = pendingIndex > 0 ? pendingInvoiceIds[pendingIndex - 1] : undefined;
    const leaveCurrentInvoice = ()=>{
        if (nextInvoiceId != null) return setVisitedInvoiceId(nextInvoiceId);
        setWalkCompleted(true);
    };
    const isChainedFlow = affectedInvoiceIds.length > 0;
    return {
        invoiceId: (_ref1 = currentInvoiceId !== null && currentInvoiceId !== void 0 ? currentInvoiceId : payload === null || payload === void 0 ? void 0 : payload.invoice.id) !== null && _ref1 !== void 0 ? _ref1 : '',
        allHandled: isChainedFlow && currentInvoiceId == null,
        onInvoiceApproved: ()=>{
            if (currentInvoiceId != null) setApprovedInvoiceIds((approved)=>[
                    ...approved,
                    currentInvoiceId
                ]);
            leaveCurrentInvoice();
        },
        chainedApproval: walkOrder.length > 1 && currentInvoiceId != null ? {
            currentInvoiceNumber: walkOrder.indexOf(currentInvoiceId) + 1,
            totalInvoices: walkOrder.length,
            onSkip: leaveCurrentInvoice,
            back: walkOrder.indexOf(currentInvoiceId) > 0 ? {
                disabled: previousInvoiceId == null,
                onClick: ()=>previousInvoiceId != null && setVisitedInvoiceId(previousInvoiceId)
            } : undefined
        } : undefined
    };
};
